export interface EmojiItem {
  emoji: string;
  name: string;
  keywords: string[];
  category: "education" | "tech" | "science" | "business" | "general";
}

export const CATEGORY_LABELS: Record<EmojiItem["category"], string> = {
  education: "Education",
  tech: "Tech",
  science: "Science",
  business: "Business",
  general: "General",
};

export const EMOJIS: EmojiItem[] = [
  // Education
  { emoji: "📘", name: "blue book", keywords: ["book", "study", "learn"], category: "education" },
  { emoji: "📚", name: "books", keywords: ["library", "study", "reading"], category: "education" },
  { emoji: "🎓", name: "graduation cap", keywords: ["school", "degree", "university"], category: "education" },
  { emoji: "📝", name: "memo", keywords: ["notes", "write", "pencil"], category: "education" },
  { emoji: "📖", name: "open book", keywords: ["reading", "literature"], category: "education" },
  { emoji: "✏️", name: "pencil", keywords: ["write", "edit", "draw"], category: "education" },

  // Tech
  { emoji: "💻", name: "laptop", keywords: ["coding", "programming", "computer"], category: "tech" },
  { emoji: "🧠", name: "brain", keywords: ["ai", "intelligence", "thinking"], category: "tech" },
  { emoji: "⚙️", name: "gear", keywords: ["settings", "config", "engine"], category: "tech" },
  { emoji: "🔐", name: "lock", keywords: ["security", "password", "auth"], category: "tech" },
  { emoji: "🤖", name: "robot", keywords: ["ai", "bot", "automation"], category: "tech" },

  // Science
  { emoji: "🔬", name: "microscope", keywords: ["biology", "research", "lab"], category: "science" },
  { emoji: "🧪", name: "test tube", keywords: ["chemistry", "experiment"], category: "science" },
  { emoji: "📐", name: "triangle ruler", keywords: ["math", "geometry", "measure"], category: "science" },
  { emoji: "🧬", name: "dna", keywords: ["genetics", "biology", "helix"], category: "science" },

  // Business
  { emoji: "📈", name: "chart increasing", keywords: ["growth", "analytics", "stats"], category: "business" },
  { emoji: "💼", name: "briefcase", keywords: ["work", "job", "career"], category: "business" },
  { emoji: "🏢", name: "office building", keywords: ["corporate", "company"], category: "business" },
  { emoji: "💰", name: "money bag", keywords: ["finance", "wealth", "budget"], category: "business" },

  // General
  { emoji: "🔥", name: "fire", keywords: ["hot", "intense", "trending"], category: "general" },
  { emoji: "⭐", name: "star", keywords: ["favorite", "best", "rating"], category: "general" },
  { emoji: "🚀", name: "rocket", keywords: ["launch", "fast", "startup"], category: "general" },
  { emoji: "🎯", name: "target", keywords: ["goal", "aim", "focus"], category: "general" },
  { emoji: "💡", name: "lightbulb", keywords: ["idea", "tip", "insight"], category: "general" },
  { emoji: "🎨", name: "palette", keywords: ["art", "design", "creative"], category: "general" },
];
